/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListOktaResourceConnectionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListOktaResourceConnectionsRequest = {
  /**
   * Include connected, verified and not-applicable servers.
   */
  includeAll?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListOktaResourceConnectionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOktaResourceConnectionsSecurity$outboundSchema: z.ZodMiniType<
  ListOktaResourceConnectionsSecurity$Outbound,
  ListOktaResourceConnectionsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listOktaResourceConnectionsSecurityToJSON(
  listOktaResourceConnectionsSecurity: ListOktaResourceConnectionsSecurity,
): string {
  return JSON.stringify(
    ListOktaResourceConnectionsSecurity$outboundSchema.parse(
      listOktaResourceConnectionsSecurity,
    ),
  );
}

/** @internal */
export type ListOktaResourceConnectionsRequest$Outbound = {
  include_all: boolean;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOktaResourceConnectionsRequest$outboundSchema: z.ZodMiniType<
  ListOktaResourceConnectionsRequest$Outbound,
  ListOktaResourceConnectionsRequest
> = z.pipe(
  z.object({
    includeAll: z._default(z.boolean(), false),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      includeAll: "include_all",
      gramSession: "Gram-Session",
    });
  }),
);

export function listOktaResourceConnectionsRequestToJSON(
  listOktaResourceConnectionsRequest: ListOktaResourceConnectionsRequest,
): string {
  return JSON.stringify(
    ListOktaResourceConnectionsRequest$outboundSchema.parse(
      listOktaResourceConnectionsRequest,
    ),
  );
}
